import { TState, TActionTypes, ActionTypes } from './types'

const INITIAL_STATE: TState = {
  layout: {
    auth: {
      header: {
        show: true,
      },
      footer: {
        show: true,
      },
    },
    dash: {
      header: {
        title: '',
        icon: {
          icon: '',
        },
      },
    },
  },
  view: {
    to: '',
    from: '',
  },
}

/**
 * @function reducer
 * @param state
 * @param action
 */
export default function reducer(
  state = INITIAL_STATE,
  action: TActionTypes,
): TState {
  switch (action.type) {
    case ActionTypes.VIEW_CHANGE_LAYOUT:
      return { ...state, layout: action.payload }

    case ActionTypes.VIEW_REMOVE_DATA:
      return INITIAL_STATE

    case ActionTypes.VIEW_CHANGE:
    default:
      return {
        ...state,
        view:
          JSON.parse(sessionStorage.getItem('current_view') as string) ??
          state.view,
      }
  }
}
